import { useState } from "react";
function l(o, e) {
  let [n, t] = useState(e);
  return !o && n !== e && t(e), o ? n : e;
}
export {
  l as useFrozenData
};
